import React from "react";

export const MostlyCloudyNightIcon = () => (
    <svg
        tabIndex={-1}
        focusable="false"
        className="svg-icon icon-weather"
        width="80px"
        height="80px"
        fill="none"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g className="weather-fill" id="27" fillRule="nonzero" fill="#717277">
                <g transform="translate(2.000000, 10.000000)">
                    <path
                        d="M3.667 40.402c0 8.498 6.988 15.377 15.596 15.377h45.652C71.584 55.78 77 50.448 77 43.86c0-2.586-.839-5.05-2.365-7.085a1.55 1.55 0 00-2.479 1.86 8.667 8.667 0 011.745 5.225c0 4.867-4.017 8.822-8.986 8.822H19.263c-6.908 0-12.498-5.503-12.498-12.279 0-6.518 5.189-11.9 11.793-12.26a1.55 1.55 0 001.457-1.384c.79-7.535 7.274-13.326 15.05-13.326 6.416 0 12.066 3.96 14.223 9.782a1.55 1.55 0 002.906-1.077c-2.607-7.034-9.413-11.804-17.128-11.804-8.92 0-16.442 6.347-17.954 14.837-7.62 1.036-13.445 7.483-13.445 15.232z"
                        fill="#717277"
                    />
                    <path
                        d="M67.026 10.404c1.532.158 1.921 2.21.554 2.917a8.709 8.709 0 003.997 16.449 8.68 8.68 0 003.201-.607c1.432-.566 2.724 1.077 1.836 2.335a13.41 13.41 0 01-10.975 5.69c-7.416 0-13.428-6.012-13.428-13.428 0-7.415 6.012-13.427 13.428-13.427.465 0 .928.024 1.387.071zM55.31 23.761c0 5.704 4.624 10.328 10.329 10.328 1.77 0 3.463-.447 4.951-1.261-6.059-.502-10.82-5.579-10.82-11.767 0-2.58.835-5.012 2.292-6.993-3.942 1.455-6.752 5.246-6.752 9.693z"
                        fill="#717277"
                    />
                </g>
            </g>
        </g>
    </svg>
);
